import Vue from 'vue'
import store from '../store'

const user = {
  check() {
    return store.state.token
  },
  isAdmin() {
    return store.state.admin
  }
}

export default {
  auth(to:any, from:any, next:any) {
    next(user.check() ? true : {
      name: 'login'
    })
  },
  admin(to:any, from:any, next:any) {
    next(user.isAdmin() ? true : {
      name: 'sites'
    })
  },
  isNotAuth(to:any, from:any, next:any) {
    if (user.check() === null)
     next()
    else
      next(from)
  }
}
